import gql from 'graphql-tag';

export const UpdateDispatchIssue = gql`
  mutation UpdateDispatchIssueBulk($input: UpdateDispatchIssueBulkInput!) {
    updateDispatchIssueBulk(input: $input) {
      response {
        updated
        error {
          code
          message
          debug
        }
      }
    }
  }
`;
